module.exports = __webpack_public_path__ + "static/media/white-logo.ed894f56.png";